<template>
  <ion-header>
    <ion-row>
      <ion-col size="9" class="ion-padding-top">
        <ion-row class="ion-justify-content-center">
          <ion-col size="auto">
            <h4 size="medium">Nuovo Evento</h4>
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-col class="ion-align-items-center ion-margin-top">
        <ion-icon
          class="arrow-down"
          @click="closeModal"
          :icon="close"
        ></ion-icon>
      </ion-col>
    </ion-row>
  </ion-header>
  <ion-content>
    <ion-card class="no-background">
      <ion-list lines="none">
        <ion-item>
          <ion-label position="stacked">Nome Cliente</ion-label>
          <ion-input
            v-model="item.nomeCliente"
            inputmode="text"
            maxlength="50"
            required
            placeholder="Scrivi il nome del cliente..."
          ></ion-input>
        </ion-item>
        <div class="length-indicator">{{ item.nomeCliente.length }}/ 50</div>
        <ion-item class="ion-margin-top">
          <ion-label position="stacked">Seleziona data e ora</ion-label>
          <ion-datetime
            presentation="date-time"
            v-model="datetime"
            prefer-wheel="true"
          ></ion-datetime>
        </ion-item>
        <br />
        <ion-item>
          <ion-label position="stacked"> Luogo della rilevazione </ion-label>
          <ion-input
            type="text"
            inputmode="text"
            v-model="item.numeroCommessa"
            placeholder="Luogo della rilevazione..."
          >
          </ion-input>
        </ion-item>
        <br />

        <ion-item>
          <ion-label position="stacked">Note</ion-label>
          <ion-textarea placeholder="Note..."> </ion-textarea>
        </ion-item>
      </ion-list>
    </ion-card>
    <div class="post-pic">
      <div class="input">
        <label>
          <ion-icon :icon="add" class="camera-icon"></ion-icon>
          <ion-icon
            :icon="document"
            @click="addFiles()"
            class="camera-icon"
          ></ion-icon>
        </label>
        <input type="file" ref="files" @change="handleFilesUpload($event)" />
      </div>
      <!-- <span v-if="previewImgUrl">file - {{(Math.random() * 100000000).toFixed(0)}}</span> -->
      <div style="width: 70vw; overflow-y: scroll; max-heigth: 100px">
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-bottom: 1rem;
            margin-left: 0.3rem;
          "
          v-for="(item, i) of files"
          :key="i"
        >
          <span>{{ item.name }} </span>
          <span>{{ new Date(item.lastModified).toLocaleDateString("it-IT") }}</span>
        </div>
        <!-- <div style="display: flex; justify-content: space-between; margin-bottom: 1rem; margin-left:.3rem">
          <div>bar1.JPG </div>
          <div> 29/09/22</div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 1rem; margin-left:.3rem">
          <div>bar2.JPG </div>
          <div> 29/09/22</div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 1rem; margin-left:.3rem">
          <div>macchina.JPG </div>
          <div> 29/09/22</div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 1rem; margin-left:.3rem">
          <div>si-allontana.JPG </div>
          <div> 29/09/22</div>
        </div> -->
      </div>
    </div>
  </ion-content>
  <ion-row class="ion-justify-content-center">
    <ion-col size="auto">
      <ion-button
        v-if="!loading"
        :disabled="notValidTicket"
        @click="sendTicket"
      >
        Invia</ion-button
      >
      <ion-button v-else @click="sendTicket" disabled> Loading...</ion-button>
    </ion-col>
  </ion-row>

  <ion-alert
    :is-open="isOpenRef"
    header="Associa il file alla data corretta"
    message="La data selezionata e la data del file inserito non coincidono"
    :buttons="['OK']"
    @didDismiss="setClose()"
  >
  </ion-alert>
</template>

<script>
import {
  IonAlert,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonLabel,
  IonInput,
  IonSelect,
  IonSelectOption,
  IonList,
  IonItem,
  IonTextarea,
  IonCard,
  modalController,
  IonDatetime,
} from "@ionic/vue"
import { close, document, add } from "ionicons/icons"
import UserService from "../../common/mixins/User"

import ApiService from "../../common/service.api"
import { uploadFile, fileInfo } from "@/utils/uploadFile"
import { buildErrorDetails, showErrorDetails } from "@/utils/errorDetails"
import { defineComponent, getCurrentScope } from "vue"

export default defineComponent({
  components: {
    IonAlert,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonRow,
    IonCol,
    IonButton,
    IonIcon,
    IonLabel,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonList,
    IonItem,
    IonTextarea,
    IonCard,
    IonDatetime,
  },
  name: "ModalNewKpiChat",

  props: {
    options: Array,
  },
  data() {
    return {
      loading: false,
      description: "",
      item: {
        data: new Date(),
        nomeCliente: "",
        numeroCommessa: "",
        created_by: 0,
        created_by_string: "",
        product_id: 0,
        product_text: "",
        id_status: 1,
        status_text: "",
        need_reply: true,
        solved: true,
        kpiValue: 0,
        margineValue: 0,
      },

      firstMessage: "",
      userId: 0,
      files: [],

      opzioneSelezionata: 0,
      previewImgUrl: "",
      idOreder: 0,
      add,
      close,
      document,
      datetime: "",
      isOpenRef: false,
    }
  },
  mixins: [UserService],
  created() {
    this.resetData()
    this.getCurrentUser().then((res) => {
      this.item.created_by = res.id
      this.userId = res.id
    })
  },
  methods: {
    resetData() {
      this.item = {
        data: new Date(),
        nomeCliente: "",
        numeroCommessa: "",
        created_by: 0,
        created_by_string: "",
        product_id: 0,
        product_text: "",
        id_status: 1,
        status_text: "",
        need_reply: true,
        solved: true,
        kpiValue: 0,
        margineValue: 0,
      }
      this.firstMessage = ""
    },
    closeModal() {
      return modalController.dismiss()
    },
    async sendTicket() {
      if (this.loading) return
      this.loading = true
      this.item.product_id = this.opzioneSelezionata

      // 1. upload attachments first: if one fails nothing has been created yet and the user can retry
      const uploadedFiles = []
      for (const file of this.files) {
        try {
          uploadedFiles.push({ file_url: await uploadFile(file) })
        } catch (err) {
          console.error("[AxertaNewLog] errore upload", err)
          this.loading = false
          showErrorDetails(
            "Errore nel caricamento del file",
            buildErrorDetails(err, { azione: "Upload allegato nuovo log", file: fileInfo(file) })
          )
          return
        }
      }

      // 2. create the order, 3. send the first message with the attachments
      let azione = "SalesChat/InsertOrder"
      try {
        const res = await ApiService.post("SalesChat/InsertOrder", this.item)
        console.log("SALES CHAT / INSERT ORDER ->  RES: ", res)
        this.idOreder = res.data.id

        azione = "SalesChat/NewMessage"
        await this.sendMessage(uploadedFiles)
        this.closeModal()
      } catch (err) {
        console.error("[AxertaNewLog] errore " + azione, err)
        showErrorDetails(
          "Errore nella creazione del log",
          buildErrorDetails(err, { azione, idOrder: this.idOreder, files: uploadedFiles })
        )
      } finally {
        this.loading = false
      }
    },

    addFiles() {
      this.$refs.files.click()
    },
    handleFilesUpload(e) {
      const file = e.target.files[0]
      // allow picking the same file again
      e.target.value = ""
      if (!file) return

      // compare calendar day only; `lastModified` (number) works everywhere, `lastModifiedDate` not in Safari
      const selected = this.datetime ? new Date(this.datetime) : null
      const fileDate = new Date(file.lastModified)
      const sameDay =
        selected &&
        !isNaN(selected) &&
        selected.toDateString() === fileDate.toDateString()

      if (!sameDay) {
        this.isOpenRef = true
      } else {
        this.previewImgUrl = URL.createObjectURL(file)
        this.files.push(file)
      }
    },
    setClose() {
      this.isOpenRef = false
    },
    async sendMessage(uploadedFiles = []) {
      const message = {
        id: null,
        data: new Date().toJSON(),
        message:
          this.firstMessage.length > 0
            ? this.firstMessage
            : this.item.numeroCommessa + " - " + this.item.nomeCliente,
        userType: "U",
        id_user: this.userId,
        files: uploadedFiles,
      }
      console.log("MESSAGE TO SEND ", message)
      const res = await ApiService.post(
        "SalesChat/NewMessage?idOrder=" + this.idOreder,
        message
      )
      if (res) {
        console.log("EVENTO INVIATO NUOVA CONVERSAZIONE CREATA", res)
        this.$emit("nuovaConversazioneCreata")
      }
    },
  },
  computed: {
    notValidTicket() {
      let item = this.item
      if (
        //   item.id == 0 ||
        item.nomeCliente == "" ||
        item.numeroCommessa == 0 ||
        item.created_by == 0 ||
        this.opzioneSelezionata == 0
        //   item.kpiValue == 0
      ) {
        return true
      }
      return false
    },
    computed_margine_type() {
      let value = 0
      if (this.opzioneSelezionata != 0) {
        this.options.forEach((element) => {
          if (element.value == this.opzioneSelezionata) {
            value = element.margine_type
          }
        })
      } else {
        value = "euro"
      }
      return value
    },
    computed_margine_value() {
      let value = 0
      if (this.opzioneSelezionata != 0) {
        this.options.forEach((element) => {
          if (element.value == this.opzioneSelezionata) {
            value = element.margine
          }
        })
      } else {
        value = "euro"
      }
      return value
    },
  },
  watch: {
    opzioneSelezionata: {
      deep: true,
      handler(o, n) {
        this.options.forEach((element) => {
          if (element.value == this.opzioneSelezionata) {
            this.item.kpiValue = element.margine
          }
        })
      },
    },
  },
})
</script>

<style scoped>
/* * {
  border: 1px solid greenyellow;
} */

.emmanuele {
  border: 1px solid red;
}

ion-item {
  border: 1px solid rgb(172, 170, 170);
  border-radius: 15px;
}

ion-icon {
  font-size: 2rem;
  margin-bottom: 8px;
  color: rgb(141, 141, 141);
}

.arrow-down {
  margin: 8px 0;
}

.length-indicator {
  position: absolute;
  top: 1.5rem;
  right: 1rem;
  z-index: 1;
}

.post-pic {
  display: grid;
  place-items: center;
  width: 100%;
}

.post-pic img {
  width: 100%;
  height: auto;
  filter: opacity(0.5);
  border-radius: 15px;
}

.camera-icon {
  /* margin-top: 3rem; */
  color: var(--ion-color-primary);
  font-size: 1rem;
}

input[type="file"] {
  position: absolute;
  top: -500px;
}

.fatturato {
  position: relative;
}

.valuta {
  position: absolute;
  bottom: 0;
  right: 1rem;
  font-size: 1rem;
}
</style>
